// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"efc28ce7","598":"9ac68c8c","703":"47e8478d","787":"83089f36"}[chunkId] + ".chunk.js";
};